import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {IonicModule} from '@ionic/angular';
import {SmOverflowTooltipModule} from '../sm-overflow-tooltip/sm-overflow-tooltip.module';
import {SmActionButtonComponent} from './sm-action-button.component';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    SmOverflowTooltipModule,
  ],
  declarations: [SmActionButtonComponent],
  exports: [SmActionButtonComponent],
})
export class SmActionButtonModule {}
